import React from "react";
import { addIdsToHeadings } from "@/helpers/addIdsToHeadings";

/**
 * Renders a string as html.
 *
 * This should only be used for translations, since it's potentially dangerous.
 */
export const SLHtmlFromLangFile = (props: {
  htmlString: string;
  /**
   * By default, the html is rendered inside a span.
   */
  component?: keyof React.JSX.IntrinsicElements;
  /**
   * Whether to add IDs to heading tags (h1-h6) for anchor linking.
   * Defaults to false.
   */
  addHeadingIds?: boolean;
}): React.JSX.Element => {
  const Component = props.component || "span";

  const htmlString = props.htmlString ?? "";

  // Optionally process HTML to add IDs to headings
  const processedHtml = props.addHeadingIds
    ? addIdsToHeadings(htmlString)
    : htmlString;

  return (
    <Component
      dangerouslySetInnerHTML={{
        __html: processedHtml,
      }}
      className="rvo-no-paragraph-margins rvo-html-content-from-lang-file"
      style={{ maxWidth: "100%" }}
    />
  );
};
